
import { Component, Prop, Vue } from 'vue-property-decorator'
import TitlePage from '@/components/atoms/TitlePage.vue'
import LabelBase from '@/components/atoms/LabelBase.vue'
import PanelFrame from '@/components/molecules/PanelFrame.vue'
import ButtonLogin from '@/components/molecules/ButtonLogin.vue'
import InputPassword from '@/components/molecules/InputPassword.vue'

/**
 * パスワード強制変更ページのフォーマット
 *   生徒以外のユーザにも展開できるよう仮設定
 */
@Component({
  components: {
    TitlePage,
    LabelBase,
    PanelFrame,
    ButtonLogin,
    InputPassword,
  },
})
export default class ForceChangePassword extends Vue {
  /** パスワード更新処理 */
  @Prop()
  eventUpdatePassword!: (password: string, confirmPassword: string) => Promise<void>

  /** パスワード */
  private password = ''

  /** パスワード(確認) */
  private confirmPassword = ''

  /**
   * 入力チェック
   *
   * @returns パスワードが正しく入力済みでない場合はtrueを返す
   */
  private get isButtonDisabled(): boolean {
    return this.password === '' || this.confirmPassword === ''
  }

  /**
   * パスワード更新ボタンクリック時処理
   */
  private async updatePassword(): Promise<void> {
    await this.eventUpdatePassword(this.password, this.confirmPassword)
  }
}
